import { type TGlobalFunctionTyped } from 'common/hooks/useTranslation';
import type { Company } from 'modules/app/hooks/useCompany';

import { type SchemeType } from '../../models/mileageScheme';

export const getSchemeTipMessage = (
  schemeType: SchemeType,
  t: TGlobalFunctionTyped,
) => {
  if (isFrenchScheme(schemeType)) {
    return t('requests.panel.frenchRatesNotice');
  }

  if (isGermanScheme(schemeType)) {
    return t('requests.panel.germanRatesNotice');
  }

  if (isUKScheme(schemeType)) {
    return t('requests.panel.ukRatesNotice');
  }
};

export const isFrenchScheme = (schemeType: SchemeType) => schemeType === 'FR';
export const isGermanScheme = (schemeType: SchemeType) => schemeType === 'DE';
export const isUKScheme = (schemeType: SchemeType) => schemeType === 'UK';

export const getCompanyDistanceUnit = (company?: Company) =>
  company?.mileage_scheme?.distanceUnit ?? 'km';

type APIVehicle = {
  type: 'car' | 'motorcycle' | 'bike';
  administrativePower?: string;
  engineSize?: string;
  fuelType?: 'electric' | undefined;
};

export const reshapeVehicleToSend = ({
  type,
  administrativePower,
  fuelType,
}: {
  type: 'car' | 'motorcycle' | 'bike';
  administrativePower?: string;
  fuelType?: 'electric' | undefined;
}): APIVehicle => {
  const vehicleToSend: APIVehicle = { type, fuelType };
  const vehicleHPower = administrativePower ?? '';
  if (type === 'car') {
    vehicleToSend.administrativePower = vehicleHPower;
  } else if (type === 'motorcycle') {
    if (vehicleHPower === '<=50cc') {
      vehicleToSend.engineSize = vehicleHPower;
    } else {
      vehicleToSend.engineSize = '>50cc';
      vehicleToSend.administrativePower = vehicleHPower;
    }
  }
  return vehicleToSend;
};

export const displayValidityDistance = (
  {
    lowerBound,
    upperBound,
  }: {
    lowerBound?: number;
    upperBound?: number;
  },
  unit: 'km' | 'mi',
) => {
  if (lowerBound && upperBound) {
    return `${lowerBound}-${upperBound}${unit}`;
  }
  if (lowerBound) {
    return `${lowerBound}${unit}+`;
  }
  if (upperBound) {
    return `0-${upperBound}${unit}`;
  }
  return '';
};

export const mapSchemetoVehicleScheme = (
  scheme: 'fr' | 'de' | 'fx' | 'legacy-uk',
) => {
  switch (scheme) {
    case 'fr':
      return 'FR';
    case 'de':
      return 'DE';
    case 'fx':
      return 'FX';
    case 'legacy-uk':
      return 'UK';
    default:
      return scheme;
  }
};
